const downloadGallery = () => {
    document.getElementById('downloadBtn')?.addEventListener('click', function () {
        const postId = this.dataset.postId;

        window.location.href = `/wp-admin/admin-ajax.php?action=download_gallery&post_id=${postId}`;
    });

}

export default downloadGallery;